import styled from 'styled-components';

export const ArrowSC = styled.div`
  display: inline;
  position: relative;
  padding-left: 8px;
`;
